import { render, staticRenderFns } from "./UCIrvineChem1LDELN1OIProcedureQualitativeObservations1.vue?vue&type=template&id=0b4075cc&scoped=true&"
import script from "./UCIrvineChem1LDELN1OIProcedureQualitativeObservations1.vue?vue&type=script&lang=ts&"
export * from "./UCIrvineChem1LDELN1OIProcedureQualitativeObservations1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4075cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFileInput,VForm,VRow})
